import { deserialize } from 'cerialize'
import { getDate } from 'Helpers'
import { USER_STATUS } from 'Pages/bankEmployees'

type User = {
	id: number
	last_name_with_initials: string
}

export class BankEmployeesModel {
	@deserialize public id: string
	@deserialize public last_name_with_initials: string
	@deserialize public user_status: string
	@deserialize public roles_names: string
	@deserialize public territorial_bank_name: string

	@deserialize public current_time_off: {
		id: string
		user_status: string
		kind: string
		start_date: string
		end_date: string
		user: User
		substitution: User
	}

	public get start_date(): string {
		return getDate(this?.current_time_off?.start_date)
	}

	public get status(): string {
		return this?.current_time_off?.user_status ?? USER_STATUS.ACTIVE
	}
}
